/* src/app/global/visualizacao/fragmentos/layout-lateral/layout-lateral.component.scss */
:host {
  display: contents;
}
.sidebar {
  flex-shrink: 0;
}
.sidebar.collapsed {
  width: 0;
  overflow: hidden;
}
.sidebar nav {
  scrollbar-width: none;
  overflow-y: auto;
  flex: 1;
}
.sidebar nav::-webkit-scrollbar {
  display: none;
}
.sidebar-item {
  text-decoration: none;
}
.sidebar-item:hover {
  text-decoration: none;
  background-color: #f3f4f5;
  color: #001e40;
}
.sidebar-label {
  animation: labelFadeIn 0.15s ease-out forwards;
}
@keyframes labelFadeIn {
  from {
    opacity: 0;
    transform: translateX(-6px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
.main-content {
  min-height: 0;
}
.modulo-badge {
  color: var(--brand, #00437d);
}
.modulo-badge__nome {
  margin: 0;
  font-weight: 700;
  font-size: 13px;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 220px;
}
.modulo-badge__subtitulo {
  margin: 0;
  font-size: 11.5px;
  color: var(--text-secondary, #43474f);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 220px;
}
@media (max-width: 1200px) {
  .modulo-badge {
    display: none;
  }
}
.material-symbols-outlined.\!fill-1 {
  font-variation-settings:
    "FILL" 1,
    "wght" 300,
    "GRAD" 0,
    "opsz" 24;
}
:host-context([data-theme=dark]) header {
  background-color: color-mix(in srgb, var(--surface-card) 80%, transparent) !important;
  border-color: var(--border-default) !important;
}
:host-context([data-theme=dark]) header .text-primary {
  color: var(--text-primary) !important;
}
:host-context([data-theme=dark]) header .text-on-surface-variant,
:host-context([data-theme=dark]) header .text-on-surface-variant\/70 {
  color: var(--text-secondary) !important;
}
:host-context([data-theme=dark]) header .border-outline-variant\/30 {
  border-color: var(--border-default) !important;
}
:host-context([data-theme=dark]) header .bg-surface-container-high {
  background-color: var(--surface-disabled) !important;
}
:host-context([data-theme=dark]) .theme-toggle {
  border-color: var(--border-default);
}
:host-context([data-theme=dark]) .theme-toggle:hover {
  background-color: var(--surface-disabled);
}
:host-context([data-theme=dark]) .modulo-badge {
  color: var(--brand-focus);
}
:host-context([data-theme=dark]) .modulo-badge__subtitulo {
  color: var(--text-secondary);
}
:host-context([data-theme=dark]) .sidebar {
  background-color: var(--sidebar-bg) !important;
  border-color: transparent !important;
}
:host-context([data-theme=dark]) .sidebar .border-y {
  border-color: rgba(255, 255, 255, 0.12) !important;
}
:host-context([data-theme=dark]) .sidebar-item.text-on-surface-variant {
  color: rgba(255, 255, 255, 0.72) !important;
}
:host-context([data-theme=dark]) .sidebar-item.text-primary {
  color: #ffffff !important;
  background-color: var(--brand-focus);
}
:host-context([data-theme=dark]) .sidebar-item:hover {
  background-color: rgba(255, 255, 255, 0.08) !important;
  color: #ffffff !important;
}
:host-context([data-theme=dark]) .sidebar-item .bg-primary {
  background-color: #ffffff !important;
}
:host-context([data-theme=dark]) .main-content {
  background-color: var(--surface-page);
}
/*# sourceMappingURL=layout-lateral.component.css.map */
